import { PAYMENT_US_KEYS, SELECTORS } from '$utils/constants';

document.addEventListener('DOMContentLoaded', () => {
  // get params from url
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get(PAYMENT_US_KEYS.token) as string;

  // if not token found, return to home
  if (!token) {
    window.location.href = '/';
  }
  const chaseForm = document.querySelector(SELECTORS.chaseForm) as HTMLFormElement;
  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  hiddenInput.id = 'itok';
  hiddenInput.name = 'itok';
  hiddenInput.value = token;
  chaseForm.appendChild(hiddenInput);
  chaseForm.submit();
});
